import React from 'react';
import classnames from 'classnames/bind';
import PropTypes from 'prop-types';

import UIHeader from '../UI/AuxiliaryHoc/Header';
import ImageFigure from '../UI/Image/ImageFigure';
import Link from '../UI/Link';

import CurrencySelector from './components/CurrencySelector';

import styles from './Header.module.scss';
import Config from '../../core/config';

const cx = classnames.bind(styles);

const Header = (props) => {
  const {
    className,
    logoHref,
    logoSrc,
    logoAlt,
    logoAriaLabel,
    currencySwitcher,
    onLogoClick
  } = props;
  const handleClickOnLogo = (e) => {
    if (window.dataLayer) {
      const { logo } = Config.gtm;

      window.dataLayer.push(logo);
    }
    if (onLogoClick) {
      e.preventDefault();
      e.stopPropagation();
      onLogoClick()
    }
  }

  return (
    <UIHeader className={cx('header', className)}>
      <div className={cx('header__container')}>
        {logoHref ? (
          <div className={cx('header__logo')}>
            <Link aria-label={logoAriaLabel} href={logoHref} className={cx('logo')} onClick={handleClickOnLogo}>
              <ImageFigure src={logoSrc} alt={logoAlt} ariaLabel={logoAriaLabel} />
            </Link>
          </div>
        ) : (
          <ImageFigure src={logoSrc} className={cx('header__logo')} alt="logo" />
        )}
        {currencySwitcher.currentCurrencyCode && (
          <div className={cx('header__side', 'header__side--right')}>
            <CurrencySelector data={currencySwitcher} />
          </div>
        )}
      </div>
    </UIHeader>
  )
}

Header.propTypes = {
  className: PropTypes.string,
  logoHref: PropTypes.string,
  logoSrc: PropTypes.string,
  currencySwitcher: PropTypes.shape({}),
  onLogoClick: PropTypes.func,
  logoAriaLabel: PropTypes.string,
  logoAlt: PropTypes.string,
}

Header.defaultProps = {
  className: '',
  logoHref: '',
  logoSrc: '',
  currencySwitcher: {},
  onLogoClick: null,
  logoAriaLabel: null,
  logoAlt: null,
}

export default Header;
